import { default as calculationMu3IJHr9VnMeta } from "/codebuild/output/src3809319797/src/nuxt-porovnej24/layers/travel/pages/calculation.vue?macro=true";
import { default as detailhRnBszYKjxMeta } from "/codebuild/output/src3809319797/src/nuxt-porovnej24/layers/travel/pages/detail.vue?macro=true";
import { default as inquiryxUz6wwgWYYMeta } from "/codebuild/output/src3809319797/src/nuxt-porovnej24/layers/travel/pages/inquiry.vue?macro=true";
import { default as _91_91type_93_93YCICFgZtI7Meta } from "/codebuild/output/src3809319797/src/nuxt-porovnej24/pages/kurzy/[[company]]/[[type]].vue?macro=true";
import { default as offer_45listaPjt1afwpKMeta } from "/codebuild/output/src3809319797/src/nuxt-porovnej24/layers/travel/pages/offer-list.vue?macro=true";
import { default as testingT5WbBCXgDfMeta } from "/codebuild/output/src3809319797/src/nuxt-porovnej24/pages/testing.vue?macro=true";
import { default as thankyoujjCo2YuIf9Meta } from "/codebuild/output/src3809319797/src/nuxt-porovnej24/layers/travel/pages/thankyou.vue?macro=true";
import { default as upsell103pWhuZkBMeta } from "/codebuild/output/src3809319797/src/nuxt-porovnej24/layers/travel/pages/upsell.vue?macro=true";
import { default as zadostxvi1USsRq1Meta } from "/codebuild/output/src3809319797/src/nuxt-porovnej24/.srovnejto/loans/pages/loans/uniform/zadost?macro=true";
import { default as thankWKqPYFW3xpMeta } from "/codebuild/output/src3809319797/src/nuxt-porovnej24/.srovnejto/loans/pages/loans/uniform/thank?macro=true";
import { default as srovnanicRUUYGI1i9Meta } from "/codebuild/output/src3809319797/src/nuxt-porovnej24/.srovnejto/loans/pages/loans/pujcka-na-miru/srovnani?macro=true";
import { default as pageUj4FgTIog3Meta } from "/codebuild/output/src3809319797/src/nuxt-porovnej24/.srovnejto/storyblok/pages/storyblok/page?macro=true";
import { default as headers_45testGRNxvlTI0DMeta } from "/codebuild/output/src3809319797/src/nuxt-porovnej24/.srovnejto/storyblok/pages/storyblok/headers-test?macro=true";
import { default as homepager4QYzppnfsMeta } from "/codebuild/output/src3809319797/src/nuxt-porovnej24/.srovnejto/storyblok/pages/blog/homepage?macro=true";
import { default as articlezmoMb2R0AKMeta } from "/codebuild/output/src3809319797/src/nuxt-porovnej24/.srovnejto/storyblok/pages/blog/article?macro=true";
import { default as document_45patternsUNZWmdvNqYMeta } from "/codebuild/output/src3809319797/src/nuxt-porovnej24/.srovnejto/storyblok/pages/blog/document-patterns?macro=true";
import { default as tagk2Y3XTjVwIMeta } from "/codebuild/output/src3809319797/src/nuxt-porovnej24/.srovnejto/storyblok/pages/blog/tag?macro=true";
import { default as autorsuABY1DbDVMeta } from "/codebuild/output/src3809319797/src/nuxt-porovnej24/.srovnejto/storyblok/pages/blog/autor?macro=true";
import { default as category1eBLcgGIluMeta } from "/codebuild/output/src3809319797/src/nuxt-porovnej24/.srovnejto/storyblok/pages/blog/category?macro=true";
import { default as sectionmxmrIJ0uh3Meta } from "/codebuild/output/src3809319797/src/nuxt-porovnej24/.srovnejto/storyblok/pages/blog/section?macro=true";
import { default as all_45articleskko0hxfoiZMeta } from "/codebuild/output/src3809319797/src/nuxt-porovnej24/.srovnejto/storyblok/pages/blog/all-articles?macro=true";
import { default as category9mnyZ4FVfMMeta } from "/codebuild/output/src3809319797/src/nuxt-porovnej24/.srovnejto/storyblok/pages/glossary-of-terms/category?macro=true";
import { default as articleN3W2YX0uZSMeta } from "/codebuild/output/src3809319797/src/nuxt-porovnej24/.srovnejto/storyblok/pages/glossary-of-terms/article?macro=true";
import { default as sectionHbvZSqnly5Meta } from "/codebuild/output/src3809319797/src/nuxt-porovnej24/.srovnejto/storyblok/pages/adviser/section?macro=true";
import { default as contact8bgZ7YpOTCMeta } from "/codebuild/output/src3809319797/src/nuxt-porovnej24/.srovnejto/storyblok/pages/forms/contact?macro=true";
import { default as car_45insurance_45terminationqlMFdWHAztMeta } from "/codebuild/output/src3809319797/src/nuxt-porovnej24/.srovnejto/storyblok/pages/forms/car-insurance-termination?macro=true";
import { default as calculationtDwXLFNW4sMeta } from "/codebuild/output/src3809319797/src/nuxt-porovnej24/.srovnejto/telco/pages/internet/calculation?macro=true";
import { default as thank_45you2zFPL9GbuoMeta } from "/codebuild/output/src3809319797/src/nuxt-porovnej24/.srovnejto/telco/pages/internet/thank-you?macro=true";
import { default as detailchQSqVvDpGMeta } from "/codebuild/output/src3809319797/src/nuxt-porovnej24/.srovnejto/telco/pages/internet/detail?macro=true";
import { default as inquirylDYxmBeBmKMeta } from "/codebuild/output/src3809319797/src/nuxt-porovnej24/.srovnejto/telco/pages/internet/inquiry?macro=true";
import { default as offer_45listM1a8WocBN6Meta } from "/codebuild/output/src3809319797/src/nuxt-porovnej24/.srovnejto/telco/pages/internet/offer-list?macro=true";
import { default as calculationvVvkLUR6MWMeta } from "/codebuild/output/src3809319797/src/nuxt-porovnej24/.srovnejto/telco/pages/mobile/calculation?macro=true";
import { default as thank_45youpnl2zuRCTjMeta } from "/codebuild/output/src3809319797/src/nuxt-porovnej24/.srovnejto/telco/pages/mobile/thank-you?macro=true";
import { default as inquirypAbcykaiFwMeta } from "/codebuild/output/src3809319797/src/nuxt-porovnej24/.srovnejto/telco/pages/mobile/inquiry?macro=true";
import { default as offer_45listBCXZkO1zUSMeta } from "/codebuild/output/src3809319797/src/nuxt-porovnej24/.srovnejto/telco/pages/mobile/offer-list?macro=true";
import { default as detailUsKDB5skIPMeta } from "/codebuild/output/src3809319797/src/nuxt-porovnej24/.srovnejto/telco/pages/mobile/detail?macro=true";
import { default as offern6VUhsK4fZMeta } from "/codebuild/output/src3809319797/src/nuxt-porovnej24/.srovnejto/telco/pages/packages/offer?macro=true";
import { default as inquiryYixnyeAnLmMeta } from "/codebuild/output/src3809319797/src/nuxt-porovnej24/.srovnejto/telco/pages/packages/inquiry?macro=true";
import { default as thank_45you9QLNfe6qHBMeta } from "/codebuild/output/src3809319797/src/nuxt-porovnej24/.srovnejto/telco/pages/packages/thank-you?macro=true";
import { default as calculation8bYLTMMsaNMeta } from "/codebuild/output/src3809319797/src/nuxt-porovnej24/.srovnejto/energo/pages/calculation?macro=true";
import { default as offer_45listvI9eLx618jMeta } from "/codebuild/output/src3809319797/src/nuxt-porovnej24/.srovnejto/energo/pages/offer-list?macro=true";
import { default as thank_45youLjR7bxjaLwMeta } from "/codebuild/output/src3809319797/src/nuxt-porovnej24/.srovnejto/energo/pages/thank-you?macro=true";
import { default as inquiry_45onlineT25wNjn7O7Meta } from "/codebuild/output/src3809319797/src/nuxt-porovnej24/.srovnejto/energo/pages/inquiry-online?macro=true";
import { default as detailzjOS7I87hLMeta } from "/codebuild/output/src3809319797/src/nuxt-porovnej24/.srovnejto/energo/pages/detail?macro=true";
import { default as inquiry_45phoneHIao098ymGMeta } from "/codebuild/output/src3809319797/src/nuxt-porovnej24/.srovnejto/energo/pages/inquiry-phone?macro=true";
import { default as inquiry_45custom_45offersVrlH2YUQTMeta } from "/codebuild/output/src3809319797/src/nuxt-porovnej24/.srovnejto/energo/pages/inquiry-custom-offer?macro=true";
export default [
  {
    name: "calculation",
    path: "/cestovni-pojisteni/zadani-ab/:leadId?",
    component: () => import("/codebuild/output/src3809319797/src/nuxt-porovnej24/layers/travel/pages/calculation.vue")
  },
  {
    name: "detail",
    path: "/cestovni-pojisteni/:leadId?/detail/:offerId?",
    component: () => import("/codebuild/output/src3809319797/src/nuxt-porovnej24/layers/travel/pages/detail.vue")
  },
  {
    name: "inquiry",
    path: "/cestovni-pojisteni/sjednani/:leadId?",
    component: () => import("/codebuild/output/src3809319797/src/nuxt-porovnej24/layers/travel/pages/inquiry.vue")
  },
  {
    name: "kurzy-company-type",
    path: "/kurzy/:company?/:type?",
    component: () => import("/codebuild/output/src3809319797/src/nuxt-porovnej24/pages/kurzy/[[company]]/[[type]].vue")
  },
  {
    name: "offer-list",
    path: "/cestovni-pojisteni/nabidka/:leadId?",
    component: () => import("/codebuild/output/src3809319797/src/nuxt-porovnej24/layers/travel/pages/offer-list.vue")
  },
  {
    name: "testing",
    path: "/testing",
    component: () => import("/codebuild/output/src3809319797/src/nuxt-porovnej24/pages/testing.vue")
  },
  {
    name: "thankyou",
    path: "/cestovni-pojisteni/dekujeme/:leadId?",
    component: () => import("/codebuild/output/src3809319797/src/nuxt-porovnej24/layers/travel/pages/thankyou.vue")
  },
  {
    name: "upsell",
    path: "/cestovni-pojisteni/upsell/:leadId?",
    component: () => import("/codebuild/output/src3809319797/src/nuxt-porovnej24/layers/travel/pages/upsell.vue")
  },
  {
    name: zadostxvi1USsRq1Meta?.name,
    path: "/pujcky-a-uvery/:provider(zaplo-online-pujcka|zaplo-na-splatky-online-pujcka|home-credit-online-pujcka|csob-online-pujcka|komercni-banka-pujcka|ceska-sporitelna|kamali)/zadost",
    component: () => import("/codebuild/output/src3809319797/src/nuxt-porovnej24/.srovnejto/loans/pages/loans/uniform/zadost")
  },
  {
    name: thankWKqPYFW3xpMeta?.name,
    path: "/pujcky-a-uvery/:provider(zaplo-online-pujcka|zaplo-na-splatky-online-pujcka|home-credit-online-pujcka|csob-online-pujcka|komercni-banka-pujcka|ceska-sporitelna|kamali)/:thank(dekujeme|zamitnuto-partner|zamitnuto)",
    component: () => import("/codebuild/output/src3809319797/src/nuxt-porovnej24/.srovnejto/loans/pages/loans/uniform/thank")
  },
  {
    name: srovnanicRUUYGI1i9Meta?.name,
    path: "/pujcky-a-uvery/pujcka-na-miru/srovnani",
    component: () => import("/codebuild/output/src3809319797/src/nuxt-porovnej24/.srovnejto/loans/pages/loans/pujcka-na-miru/srovnani")
  },
  {
    name: pageUj4FgTIog3Meta?.name,
    path: "/:all(.*)*",
    component: () => import("/codebuild/output/src3809319797/src/nuxt-porovnej24/.srovnejto/storyblok/pages/storyblok/page")
  },
  {
    name: headers_45testGRNxvlTI0DMeta?.name,
    path: "/headers-test",
    component: () => import("/codebuild/output/src3809319797/src/nuxt-porovnej24/.srovnejto/storyblok/pages/storyblok/headers-test")
  },
  {
    name: homepager4QYzppnfsMeta?.name,
    path: "/clanky",
    component: () => import("/codebuild/output/src3809319797/src/nuxt-porovnej24/.srovnejto/storyblok/pages/blog/homepage")
  },
  {
    name: articlezmoMb2R0AKMeta?.name,
    path: "/clanky/:article(.*)*",
    component: () => import("/codebuild/output/src3809319797/src/nuxt-porovnej24/.srovnejto/storyblok/pages/blog/article")
  },
  {
    name: document_45patternsUNZWmdvNqYMeta?.name,
    path: "/clanky/vzory-dokumentu",
    component: () => import("/codebuild/output/src3809319797/src/nuxt-porovnej24/.srovnejto/storyblok/pages/blog/document-patterns")
  },
  {
    name: tagk2Y3XTjVwIMeta?.name,
    path: "/clanky/tag/:slug(.*)*",
    component: () => import("/codebuild/output/src3809319797/src/nuxt-porovnej24/.srovnejto/storyblok/pages/blog/tag")
  },
  {
    name: autorsuABY1DbDVMeta?.name,
    path: "/clanky/autor/:slug(.*)*",
    component: () => import("/codebuild/output/src3809319797/src/nuxt-porovnej24/.srovnejto/storyblok/pages/blog/autor")
  },
  {
    name: category1eBLcgGIluMeta?.name,
    path: "/clanky/:category(kategorie)",
    component: () => import("/codebuild/output/src3809319797/src/nuxt-porovnej24/.srovnejto/storyblok/pages/blog/category")
  },
  {
    name: sectionmxmrIJ0uh3Meta?.name,
    path: "/clanky/:category(kategorie)/:section(pojisteni|hypoteky|pujcky|energie|mobilni-tarify|osobni-finance)",
    component: () => import("/codebuild/output/src3809319797/src/nuxt-porovnej24/.srovnejto/storyblok/pages/blog/section")
  },
  {
    name: all_45articleskko0hxfoiZMeta?.name,
    path: "/clanky/all-articles",
    component: () => import("/codebuild/output/src3809319797/src/nuxt-porovnej24/.srovnejto/storyblok/pages/blog/all-articles")
  },
  {
    name: pageUj4FgTIog3Meta?.name,
    path: "/slovnik-pojmu",
    component: () => import("/codebuild/output/src3809319797/src/nuxt-porovnej24/.srovnejto/storyblok/pages/storyblok/page")
  },
  {
    name: category9mnyZ4FVfMMeta?.name,
    path: "/slovnik-pojmu/:category(elektrina|hypoteky|penzijni-sporeni|plyn|povinne-ruceni|uvery|pujcky)",
    component: () => import("/codebuild/output/src3809319797/src/nuxt-porovnej24/.srovnejto/storyblok/pages/glossary-of-terms/category")
  },
  {
    name: articleN3W2YX0uZSMeta?.name,
    path: "/slovnik-pojmu/:category(elektrina|hypoteky|penzijni-sporeni|plyn|povinne-ruceni|uvery|pujcky)/:id(.*)*",
    component: () => import("/codebuild/output/src3809319797/src/nuxt-porovnej24/.srovnejto/storyblok/pages/glossary-of-terms/article")
  },
  {
    name: sectionHbvZSqnly5Meta?.name,
    path: "/radce/",
    component: () => import("/codebuild/output/src3809319797/src/nuxt-porovnej24/.srovnejto/storyblok/pages/adviser/section")
  },
  {
    name: sectionHbvZSqnly5Meta?.name,
    path: "/radce/:slug(.*)",
    component: () => import("/codebuild/output/src3809319797/src/nuxt-porovnej24/.srovnejto/storyblok/pages/adviser/section")
  },
  {
    name: contact8bgZ7YpOTCMeta?.name,
    path: "/kontakt",
    component: () => import("/codebuild/output/src3809319797/src/nuxt-porovnej24/.srovnejto/storyblok/pages/forms/contact")
  },
  {
    name: car_45insurance_45terminationqlMFdWHAztMeta?.name,
    path: "/zruseni-povinneho-ruceni-zmena-pojistovny",
    component: () => import("/codebuild/output/src3809319797/src/nuxt-porovnej24/.srovnejto/storyblok/pages/forms/car-insurance-termination")
  },
  {
    name: calculationtDwXLFNW4sMeta?.name,
    path: "/internet/kalkulace",
    component: () => import("/codebuild/output/src3809319797/src/nuxt-porovnej24/.srovnejto/telco/pages/internet/calculation")
  },
  {
    name: thank_45you2zFPL9GbuoMeta?.name,
    path: "/internet/prehled-vaseho-pozadavku",
    component: () => import("/codebuild/output/src3809319797/src/nuxt-porovnej24/.srovnejto/telco/pages/internet/thank-you")
  },
  {
    name: detailchQSqVvDpGMeta?.name,
    path: "/internet/srovnani-nabidek/:leadId?/detail",
    component: () => import("/codebuild/output/src3809319797/src/nuxt-porovnej24/.srovnejto/telco/pages/internet/detail")
  },
  {
    name: inquirylDYxmBeBmKMeta?.name,
    path: "/internet/sjednani-nabidky/:leadId?",
    component: () => import("/codebuild/output/src3809319797/src/nuxt-porovnej24/.srovnejto/telco/pages/internet/inquiry")
  },
  {
    name: offer_45listM1a8WocBN6Meta?.name,
    path: "/internet/srovnani-nabidek/:leadId?",
    component: () => import("/codebuild/output/src3809319797/src/nuxt-porovnej24/.srovnejto/telco/pages/internet/offer-list")
  },
  {
    name: calculationvVvkLUR6MWMeta?.name,
    path: "/mobilni-tarify/kalkulace",
    component: () => import("/codebuild/output/src3809319797/src/nuxt-porovnej24/.srovnejto/telco/pages/mobile/calculation")
  },
  {
    name: thank_45youpnl2zuRCTjMeta?.name,
    path: "/mobilni-tarify/prehled-vaseho-pozadavku",
    component: () => import("/codebuild/output/src3809319797/src/nuxt-porovnej24/.srovnejto/telco/pages/mobile/thank-you")
  },
  {
    name: inquirypAbcykaiFwMeta?.name,
    path: "/mobilni-tarify/sjednani-nabidky/:leadId?",
    component: () => import("/codebuild/output/src3809319797/src/nuxt-porovnej24/.srovnejto/telco/pages/mobile/inquiry")
  },
  {
    name: offer_45listBCXZkO1zUSMeta?.name,
    path: "/mobilni-tarify/srovnani-nabidek/:leadId?",
    component: () => import("/codebuild/output/src3809319797/src/nuxt-porovnej24/.srovnejto/telco/pages/mobile/offer-list")
  },
  {
    name: detailUsKDB5skIPMeta?.name,
    path: "/mobilni-tarify/srovnani-nabidek/:leadId?/detail",
    component: () => import("/codebuild/output/src3809319797/src/nuxt-porovnej24/.srovnejto/telco/pages/mobile/detail")
  },
  {
    name: offern6VUhsK4fZMeta?.name,
    path: "/balicky-sluzeb/priklad-nabidky",
    component: () => import("/codebuild/output/src3809319797/src/nuxt-porovnej24/.srovnejto/telco/pages/packages/offer")
  },
  {
    name: inquiryYixnyeAnLmMeta?.name,
    path: "/balicky-sluzeb/sjednani-nabidky",
    component: () => import("/codebuild/output/src3809319797/src/nuxt-porovnej24/.srovnejto/telco/pages/packages/inquiry")
  },
  {
    name: thank_45you9QLNfe6qHBMeta?.name,
    path: "/balicky-sluzeb/potvrzeni-objednavky",
    component: () => import("/codebuild/output/src3809319797/src/nuxt-porovnej24/.srovnejto/telco/pages/packages/thank-you")
  },
  {
    name: calculation8bYLTMMsaNMeta?.name,
    path: "/energie/kalkulace-:vertical(elektrina|plyn)/:leadId?",
    component: () => import("/codebuild/output/src3809319797/src/nuxt-porovnej24/.srovnejto/energo/pages/calculation")
  },
  {
    name: offer_45listvI9eLx618jMeta?.name,
    path: "/energie/srovnani-nabidek/:vertical(plyn|elektrina)/:leadId?",
    component: () => import("/codebuild/output/src3809319797/src/nuxt-porovnej24/.srovnejto/energo/pages/offer-list")
  },
  {
    name: thank_45youLjR7bxjaLwMeta?.name,
    path: "/energie/prehled-vaseho-pozadavku/:leadId?",
    component: () => import("/codebuild/output/src3809319797/src/nuxt-porovnej24/.srovnejto/energo/pages/thank-you")
  },
  {
    name: inquiry_45onlineT25wNjn7O7Meta?.name,
    path: "/energie/sjednani-online/:vertical(elektrina|plyn)/:leadId?",
    component: () => import("/codebuild/output/src3809319797/src/nuxt-porovnej24/.srovnejto/energo/pages/inquiry-online")
  },
  {
    name: detailzjOS7I87hLMeta?.name,
    path: "/energie/srovnani-nabidek/:vertical(plyn|elektrina)/:leadId/detail/:tariffId",
    component: () => import("/codebuild/output/src3809319797/src/nuxt-porovnej24/.srovnejto/energo/pages/detail")
  },
  {
    name: inquiry_45phoneHIao098ymGMeta?.name,
    path: "/energie/sjednani-po-telefonu/:vertical(plyn|elektrina)/:leadId?",
    component: () => import("/codebuild/output/src3809319797/src/nuxt-porovnej24/.srovnejto/energo/pages/inquiry-phone")
  },
  {
    name: inquiry_45custom_45offersVrlH2YUQTMeta?.name,
    path: "/energie/nabidka-na-miru",
    component: () => import("/codebuild/output/src3809319797/src/nuxt-porovnej24/.srovnejto/energo/pages/inquiry-custom-offer")
  }
]